// extracted by mini-css-extract-plugin
module.exports = {"container":"performanceCharts_container__20aNF","chart_container":"performanceCharts_chart_container__2b-3S","paragraph":"performanceCharts_paragraph__1o8aH"};